import { SortingState } from "@tanstack/react-table";
import { StateCreator } from "zustand";
import { MiscStore } from "./misc.slice";
import { UserStore } from "./user.slice";

export type StoredTableNav = {
  paginationMap?: { [key: number]: string };
  currentPage?: number;
  search?: string;
  sorting?: SortingState;
};

type NavState = StoredTableNav;

type NavStoreActions = {
  setNavForId(id: string, navState: NavState): void;
  getNavForId(id: string): NavState;
  clearNavForId(id: string): void;
};

type NavStoreState = {
  navMap: { [key: string]: NavState };
};

export type NavStore = NavStoreActions & NavStoreState;

export const createNavSlice: StateCreator<
  NavStore & MiscStore & UserStore,
  [["zustand/devtools", never], ["zustand/immer", never]],
  [["zustand/persist", NavStore]],
  NavStore
> = (set, get) => ({
  navMap: {},
  setNavForId: (id, navState) => {
    set((state) => {
      state.navMap[id] = navState;
    });
  },
  getNavForId: (id) => {
    return get().navMap[id];
  },
  clearNavForId: (id) => {
    set((state) => {
      const navState = state.navMap;
      navState[id] = {};
      return state;
    });
  },
});
